import React from "react";
import GLOBAL from "../../../global";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const BiometricLoader = () => {
    const { isExamineticsEnabled } = useTenantFeatures();

    return (
        <div className="biometric-loader">
            <div className="biometric-loader__icon">
                <i className="flaticon-warning"/>
            </div>
            <div className="biometric-loader__message">
                <h1>{isExamineticsEnabled ? "Please wait, the system is preparing to take your functional screening." : "Please wait, the system is preparing to take your biometric measurements."} &nbsp;&nbsp;
                    <i className="fa fa-spinner biometric-loader__spinner"/>
                </h1>
            </div>
        </div>
    );
}

export default BiometricLoader;